// Succinct hack for generating passable unique ids
const uid = () => Math.random().toString(34).slice(2);

export default uid;



// WEBPACK FOOTER //
// ./src/utils/uid.js